import React from "react";
import {CheckboxFilter, ListItem, Map, SelectFilter} from "./index";
import {RegionalPartner} from "../Interfaces/RegionalPartner";

type Props = {
    data: RegionalPartner[]
    itemsPerPage: number
}

type State = {
    configuration?: any
    itemsjs: any
    filters: any[]
    data: RegionalPartner[]
    filtersValues: any[]
}

class List extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        const configuration = {
            sortings: {
                title_asc: {
                    field: 'title',
                    order: 'asc'
                }
            },
            aggregations: {
                fuels: {
                    title: 'Fuels',
                    size: 999,
                    sort: 'key',
                    conjunction: false,
                    hide_zero_doc_count: true,
                    chosen_filters_on_top: false
                },
                offers: {
                    title: 'Offers',
                    size: 999,
                    sort: 'key',
                    conjunction: false,
                    hide_zero_doc_count: true,
                    chosen_filters_on_top: false
                },
                canton: {
                    title: 'Canton',
                    size: 999,
                    sort: 'key',
                    conjunction: false,
                    hide_zero_doc_count: true,
                    chosen_filters_on_top: false
                }
            },
            searchableFields: ['title']
        }

        const itemsjs = require('itemsjs')(this.props.data, configuration)

        const newFilters: any[] = []
        const filtersValues: any[] = []

        Object.keys(configuration.aggregations).forEach((v: any) => {
            filtersValues[v] = [];
            const filter = itemsjs.aggregation({
                name: v,
                per_page: 999
            })
            newFilters[v] = filter.data
        })

        this.state = {
            configuration: configuration,
            itemsjs: itemsjs,
            filters: newFilters,
            data: this.props.data,
            filtersValues: filtersValues
        }
    }

    handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const filterName: any = event.target.dataset.filter
        const filterValue = event.target.value
        let filtersValues = this.state.filtersValues

        let check = event.target.checked
        if (this.state.filters) {
            if (check) {
                filtersValues[filterName].push(filterValue)
            } else {
                var index = filtersValues[filterName].indexOf(filterValue)
                if (index > -1) {
                    filtersValues[filterName].splice(index, 1)
                }
            }
        }

        this.afterFilterChange(filtersValues)
    }

    handleSelectChange = (selectedList:any[], selectedItem:any) => {
        let filterName:any = ''
        Object.keys(this.state.filters).forEach((filter:any) => {
            if(this.state.filters[filter].buckets.filter((element:any) => element.key === selectedItem.key).length > 0) {
                filterName = filter
            }
        })

        if(!filterName) {
            Object.keys(this.state.filtersValues).forEach((filter:any) => {
                if(this.state.filtersValues[filter].filter((element:any) => element === selectedItem.key).length > 0) {
                    filterName = filter
                }
            })
        }

        const filterValue = selectedItem.key
        let filtersValues: any[] = this.state.filtersValues
        filtersValues[filterName] = []
        if(filterValue !== '0') {
            for(let i = 0; i < selectedList.length; i++) {
                filtersValues[filterName].push(selectedList[i].key)
            }
        }

        this.afterFilterChange(filtersValues)
    }

    afterFilterChange = (filtersValues: any[]) => {
        const data = this.state.itemsjs.search({
            per_page: this.props.data.length,
            sort: 'title_asc',
            filters: filtersValues
        })

        const updatedFilters: any[] = []
        Object.keys(data.data.aggregations).forEach((v: any) => {
            updatedFilters[v] = data.data.aggregations[v]
        })

        this.setState({
            data: data.data.items,
            filters: updatedFilters,
            filtersValues: filtersValues
        })
    }

    renderFilter = (buckets: RegionalPartner[], filter: string, index: number) => {
        switch (filter) {
            case 'canton':
            case 'offers':
                return <SelectFilter
                    key={index}
                    buckets={buckets}
                    filter={filter}
                    onSelect={this.handleSelectChange}
                    onRemove={this.handleSelectChange}
                />
            default:
                return <CheckboxFilter
                    key={index}
                    buckets={buckets}
                    filter={filter}
                    onChange={this.handleCheckboxChange}
                />
        }
    }

    render() {
        return (
            <>
                <div className={"regional-partners-map"}>
                    <Map data={this.state.data} zoom={8}/>
                </div>

                <div className={"regional-partners-filters"}>
                    <div className={"filters-container"}>
                        {
                            Object.keys(this.state.filters).map((filter: any, index: number) => (
                                this.renderFilter(this.state.filters[filter].buckets, filter, index)
                            ))
                        }
                    </div>
                </div>

                <div className="regional-partners-list">
                    <div className={"list-container"}>
                        <div className={"list-wrapper"}>
                            {
                                this.state.data.map((regionalPartner, index) => (
                                    <ListItem regionalPartner={regionalPartner} key={regionalPartner.id}/>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default List
